import { List } from "immutable";
import { Page } from "@utils/page";

export type PaginatedData<T, Extra = unknown> = {
	content: List<T>;
	page: number;
	total_pages: number;
	total_size: number;
} & Extra;

export function fromPageAndContent<T, Extra = unknown>(
	page: Page<T, Extra>,
	content: List<T>
): PaginatedData<T, Extra> {
	const { content: _, ...rest } = page;
	return {
		...(rest as Extra),
		content,
		page: rest.page,
		total_pages: rest.total_pages,
		total_size: rest.total_size,
	};
}
export function withNewContent<T, Extra = unknown>(
	data: PaginatedData<T, Extra>,
	content: List<T>
): PaginatedData<T, Extra> {
	const { content: _, ...rest } = data;
	return {
		...(rest as Extra),
		content,
		page: rest.page,
		total_pages: rest.total_pages,
		total_size: rest.total_size,
	};
}
